import { render, staticRenderFns } from "./Skiptirmali.vue?vue&type=template&id=0c47fe2b&scoped=true"
import script from "./Skiptirmali.vue?vue&type=script&lang=js"
export * from "./Skiptirmali.vue?vue&type=script&lang=js"
import style0 from "./Skiptirmali.vue?vue&type=style&index=0&id=0c47fe2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c47fe2b",
  null
  
)

export default component.exports